import React from "react";
import "./EmptyCart.css";
import { useTitle } from "../../hooks/useTitle";
import { ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";

function EmptyCart() {
  useTitle("Cart - TrendBay");
  return (
    <div className="empty-cart-body">
      <div className="empty-cart-icon">
        <ShoppingCart size={56} strokeWidth={1.2} />
      </div>
      <h2 className="empty-cart-title">Your Cart is Empty</h2>
      <p className="empty-cart-sub">Looks like you haven't added anything yet.</p>
      <Link to="/shop/all" className="empty-cart-btn">Start Shopping</Link>
    </div>
  );
}

export default EmptyCart;
